export default __webpack_public_path__ + "images/1c3610266a15a41d564dea3f0e0fe0fa.png";